// extracted by mini-css-extract-plugin
export default {"no_aut_container":"NotAuthenticatedView_no_aut_container__pmVit","text":"NotAuthenticatedView_text__wMPGo"};